module.exports = __webpack_public_path__ + "img/logo.6f501dd3.png";